var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.3",
    style: {
      enableBackground: "new 0 0 689.9 563.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3DDB5;}\r\n\t.st1{fill:#36504B;}\r\n\t.st2{fill:#B0F7D5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.4,
    cy: 68.1,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.8,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.8,
    cy: 174.5,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 565,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 660.9,
    cy: 410.4,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 616.6,
    cy: 534.3,
    r: 28.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M556,170.3h-45.9v-32c0-24.8-20.1-44.9-44.9-44.9H133.9c-24.8,0-44.9,20.1-44.9,44.9v208.8 c0,24.8,20.1,44.9,44.9,44.9h45.9v32c0,24.8,20.1,44.9,44.9,44.9H556c24.8,0,44.9-20.1,44.9-44.9V215.2 C600.9,190.4,580.8,170.3,556,170.3L556,170.3z M556,200.2c8.3,0,15,6.7,15,15v15h-60.9v-29.9H556z M571,290h-60.9v-29.9H571V290z  M118.9,347.1V138.3c0-8.3,6.7-15,15-15h331.4c8.3,0,15,6.7,15,15v208.8c0,8.3-6.7,15-15,15H133.9 C125.6,362,118.9,355.3,118.9,347.1z M556,438.9H224.7c-8.3,0-15-6.7-15-15v-32h255.5c24.8,0,44.9-20.1,44.9-44.9V320H571v104 C571,432.2,564.3,438.9,556,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269,302h-22.4c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15H269c8.3,0,15-6.7,15-15C284,308.7,277.3,302,269,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,302H330c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15h22.4c8.3,0,15-6.7,15-15 C367.4,308.7,360.7,302,352.4,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.7,302h-22.4c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15h22.4c8.3,0,15-6.7,15-15 C200.6,308.7,193.9,302,185.7,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.3,302h-22.4c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15h22.4c8.3,0,15-6.7,15-15 C450.2,308.7,443.5,302,435.3,302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.5,261h82.3c13.1,0,23.7-10.6,23.7-23.7V177c0-13.1-10.6-23.7-23.7-23.7h-82.3 c-13.1,0-23.7,10.6-23.7,23.7v60.3C148.8,250.4,159.5,261,172.5,261z M178.8,183.2h69.9v47.9h-69.9V183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,164.1c-6.7,4.9-8.2,14.2-3.3,20.9c5.8,8.1,8.9,17.6,8.9,27.5c0,10-3.1,19.6-9.1,27.7 c-4.9,6.7-3.4,16,3.2,20.9c2.7,2,5.8,2.9,8.8,2.9c4.6,0,9.2-2.1,12.1-6.1c9.7-13.3,14.9-29,14.9-45.4c0-16.3-5.1-31.9-14.7-45.1 C430.7,160.8,421.4,159.3,414.7,164.1L414.7,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.8,190.6c-5-6.6-14.4-7.8-21-2.7c-6.6,5-7.8,14.4-2.7,21c0.8,1,1.2,2.3,1.2,3.7c0,1.3-0.5,2.6-1.3,3.7 c-5.1,6.5-3.9,15.9,2.6,21c2.7,2.1,6,3.2,9.2,3.2c4.5,0,8.9-2,11.8-5.8c4.9-6.3,7.6-14.1,7.6-22.1 C402.3,204.7,399.6,196.9,394.8,190.6L394.8,190.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "209.7,392 475.9,392 565,435.9 224.7,438.9 213.7,434.1 209.7,423.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono5);
export default __webpack_public_path__ + "static/media/icono5.7bddd786585bd95989c33321dc554d25.svg";
export { ForwardRef as ReactComponent };